import { render, staticRenderFns } from "./summary-dashboard.vue?vue&type=template&id=166423a2&scoped=true&"
import script from "./summary-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./summary-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./summary-dashboard.scss?vue&type=style&index=0&id=166423a2&lang=scss&scoped=true&"
import style1 from "./summary-dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166423a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166423a2')) {
      api.createRecord('166423a2', component.options)
    } else {
      api.reload('166423a2', component.options)
    }
    module.hot.accept("./summary-dashboard.vue?vue&type=template&id=166423a2&scoped=true&", function () {
      api.rerender('166423a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/milk-run/summary-dashboard/summary-dashboard.vue"
export default component.exports